















import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    type: String,
    name: String,
    value: [String, Number, Boolean, Date],
    readonly: Boolean,
    min: Number,
    size: Number,
    max: Number
  }
})
